// Запросы аутентификации сотрудника к бэкенду.
// ВАЖНО: эндпоинт ещё не реализован на бэкенде — вызов проводной, форма-контракт
// зафиксирован здесь, бэкенд под него подстраивается.

import { api } from '@/api/client'
import type { StaffRole } from './storage'

export interface StaffProfile {
  id: string
  email: string
  role: StaffRole
  /** null для super_admin (кросс-клубный доступ) */
  clubId: string | null
  name?: string | null
}

/**
 * Ожидаемый ответ бэкенда на POST /v1/auth/login.
 * token — JWT сотрудника; staff — профиль для отображения.
 */
export interface LoginResponse {
  token: string
  staff: StaffProfile
}

export interface LoginRequest {
  email: string
  password: string
}

/** POST ${API}/v1/auth/login → { token, staff } (+ ставит httpOnly-cookie). */
export function login(body: LoginRequest): Promise<LoginResponse> {
  return api.post<LoginResponse>('/v1/auth/login', body, { anonymous: true })
}

/** POST ${API}/v1/auth/logout — гасит httpOnly-cookie сессии на сервере. */
export function logout(): Promise<void> {
  return api.post<void>('/v1/auth/logout')
}

/**
 * POST ${API}/v1/auth/sso-exchange — обмен одноразового кода из Help (SupportHub)
 * на staff-сессию. Публичный маршрут (anonymous: true) — на странице /sso
 * пользователь ещё не залогинен, cookie появится только этим запросом.
 */
export function ssoExchange(code: string): Promise<LoginResponse> {
  return api.post<LoginResponse>('/v1/auth/sso-exchange', { code }, { anonymous: true })
}

/**
 * POST ${API}/v1/auth/set-password — пароль по одноразовой ссылке-приглашению
 * (письмо владельцу клуба, подключённого из Help). Публичный маршрут; успех
 * сразу открывает сессию (ставит cookie), как login.
 */
export function setPassword(token: string, password: string): Promise<LoginResponse> {
  return api.post<LoginResponse>('/v1/auth/set-password', { token, password }, { anonymous: true })
}
